// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1PrN3","addWidgetButton":"Header_addWidgetButton__2js23","dashboardTabs":"Header_dashboardTabs__2NqcZ","active":"Header_active__30olk"};